import {Component} from '@angular/core';
import {ModalComponent} from '@components/common/modal/modal.component';

@Component({
  selector: 'app-confirm',
  templateUrl: './confirm.component.html',
  styleUrls: ['./confirm.component.scss'],
})
export class ConfirmModalComponent {

  // public name = '';
  // public type = '';
  // public targetEnvironment = '';

  public message = '';
  public title = '';

  constructor(
    protected readonly parent: ModalComponent
  ) {
    this.message = parent.data?.message || '';
    this.title = parent.data?.title || '';
    // this.targetEnvironment = parent.data?.targetEnvironment || '';
  }

  public close(value: boolean): void {
    this.parent.close(value);
  }

}
